import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { User } from '../user';

@Component({
  selector: 'naas-school-banner',
  templateUrl: './school-banner.component.html',
  styleUrls: ['./school-banner.component.scss'],
})
export class SchoolBannerComponent implements OnInit {
  user: User;
  _location: string;

  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    this._location = this.router.url;
    this.route.data.subscribe(data => (this.user = data.user));
  }
}
